import { render, staticRenderFns } from "./SettingOneClickData.vue?vue&type=template&id=28395456"
import script from "./SettingOneClickData.vue?vue&type=script&lang=js"
export * from "./SettingOneClickData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports